export const Positions = [
  { label: "TE", value: "TE" },
  { label: "RB", value: "RB" },
  { label: "WR", value: "WR" },
  { label: "QB", value: "QB" },
];
